import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectInvoice = state => {
    return selectOwnState(state).invoice
}

export const selectInvoiceCorrectionData = state => {
    return selectOwnState(state).invoiceCorrectionData
}

export const selectCustomText = state => {
    return selectInvoiceCorrectionData(state).customText
}


export const selectInvoiceCorrectionPayload = state => {
    const invoice = selectInvoice(state)
    if (!invoice) {
        return null
    }
    return {
        invoiceId: invoice.id,
        customText: selectCustomText(state),
        invoiceItemCorrectionList: invoice.invoiceItemList.map(invoiceItem => ({
            originalInvoiceItemId: invoiceItem.id,
            correctionAmount: Math.round(invoiceItem.correctionAmount * 100),
        })),
    }
}



// WEBPACK FOOTER //
// ./src/modules/invoice/state/correction/selector.js